export default __webpack_public_path__ + "static/media/wots_wide_logo.5b51dda5.png";